import { render, staticRenderFns } from "./TradingTrades.vue?vue&type=template&id=90459ae6&scoped=true&"
import script from "./TradingTrades.vue?vue&type=script&lang=js&"
export * from "./TradingTrades.vue?vue&type=script&lang=js&"
import style0 from "./TradingTrades.vue?vue&type=style&index=0&id=90459ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90459ae6",
  null
  
)

export default component.exports